import styled from '@emotion/styled'
import ButtonMUI from '@mui/material/Button'

export const ExportButton = styled(ButtonMUI)`
  background: rgba(0, 174, 239, 0.11);
  color: #00aeef;
  box-shadow: none;
  padding: 5px 15px;
  &:hover {
    background: rgba(0, 174, 239, 0.11);
    box-shadow: none;
  }
`
